import { Bellhop } from 'bellhop-iframe';

export const BellhopSingleton = new Bellhop();
export default BellhopSingleton;
